import { useState } from "react";
import { Link } from "react-router-dom";
import { apiPublic, setTechSession, getTechInfo, clearTechSession } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import TechPortal from "@/pages/portals/TechPortal";

export default function TechEntry() {
  const [info, setInfo] = useState(getTechInfo());
  if (info) return <TechPortal info={info} onLogout={() => { clearTechSession(); setInfo(null); }} />;
  return <TechLogin onAuthed={setInfo} />;
}

function TechLogin({ onAuthed }) {
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  async function login() {
    setBusy(true);
    try {
      const res = await apiPublic.post("/auth/tech/login", { phone, pin });
      setTechSession(res.data);
      onAuthed(res.data.tech);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#002060] grid place-items-center px-5">
      <div className="absolute top-5 left-5">
        <Link to="/" className="text-sm text-[#FFFFFF]/80 hover:text-[#FF6600] flex items-center gap-1.5" data-testid="tech-back-home">
          <ArrowLeft className="w-4 h-4" /> Home
        </Link>
      </div>
      <div className="w-full max-w-sm bg-[#FFFFFF] border-t-4 border-[#FF6600] rounded-2xl p-7 shadow-2xl">
        <div className="flex items-center gap-3 mb-1">
          <img src="/brand/logo.png" alt="Space Appliance" className="h-10 w-10 object-contain" />
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FF6600] font-semibold">Field Technician</div>
            <h1 className="display text-2xl font-semibold tracking-tight text-[#002060]">Sign in</h1>
          </div>
        </div>
        <p className="text-[#002060]/70 text-sm mt-1">Phone + 4-digit PIN.</p>
        <div className="mt-6 space-y-4">
          <div>
            <Label className="text-sm text-[#002060]">Phone</Label>
            <Input data-testid="tech-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="2105551234" className="mt-1.5 border-[#002060]/20 focus-visible:ring-[#FF6600]" />
          </div>
          <div>
            <Label className="text-sm text-[#002060]">PIN</Label>
            <Input data-testid="tech-pin" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))} placeholder="••••" maxLength={4} className="mt-1.5 tracking-[8px] text-center text-2xl font-mono border-[#002060]/20 focus-visible:ring-[#FF6600]" />
          </div>
          <Button data-testid="tech-login-btn" disabled={busy || !phone || pin.length !== 4} onClick={login} className="w-full h-12 bg-[#FF6600] hover:bg-[#FF6600]/90 text-[#FFFFFF] font-bold uppercase tracking-widest rounded-full">
            {busy ? "…" : "Enter"}
          </Button>
        </div>
        <p className="mt-6 text-xs text-[#002060]/60">Demo: <span className="font-mono text-[#002060]">2105551234 / 1234</span></p>
      </div>
    </div>
  );
}
